var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29289 0.305288C4.38514 0.209778 4.49548 0.133596 4.61749 0.0811869C4.73949 0.0287779 4.87071 0.00119157 5.00349 3.77571e-05C5.13627 -0.00111606 5.26795 0.0241854 5.39085 0.0744663C5.51374 0.124747 5.6254 0.199 5.71929 0.292893C5.81318 0.386786 5.88743 0.498438 5.93771 0.621334C5.988 0.74423 6.0133 0.87591 6.01214 1.00869C6.01099 1.14147 5.9834 1.27269 5.93099 1.39469C5.87859 1.5167 5.8024 1.62704 5.70689 1.71929L3.41389 4.01229H12.9999C13.2651 4.01229 13.5195 4.11765 13.707 4.30518C13.8945 4.49272 13.9999 4.74707 13.9999 5.01229C13.9999 5.2775 13.8945 5.53186 13.707 5.71939C13.5195 5.90693 13.2651 6.01229 12.9999 6.01229H3.41389L5.70689 8.30529C5.88905 8.49389 5.98985 8.74649 5.98757 9.00869C5.98529 9.27089 5.88012 9.5217 5.69471 9.70711C5.5093 9.89251 5.25849 9.99768 4.99629 9.99996C4.7341 10.0022 4.4815 9.90145 4.29289 9.71929L0.292892 5.71929C0.105421 5.53176 0.000106812 5.27745 0.000106812 5.01229C0.000106812 4.74712 0.105421 4.49282 0.292892 4.30529L4.29289 0.305288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.cd3767d8f53e1b59db4429c8132d0fba.svg";
export { ForwardRef as ReactComponent };